import { FC } from 'react'
import { TableConfigurationContainer } from './components/TableConfigurationContainer'

export const TableConfiguration: FC = () => (
  <TableConfigurationContainer></TableConfigurationContainer>
)
